import React, { memo } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Journal from "pagesV2/pro/Calendar/Modals/Journal"
import styles from "./index.module.css"
import BookingDetailsModal from "pagesV2/pro/clients/ClientDetails/ClientDetailsTabs/BookingTab/BookingTable/Modals/BookingDetails"
import { useDayCell } from "./hooks/useDayCell"

const DayCell = ({
  day,
  monthStartDate,
  monthEndDate,
  timeOffRanges = [],
  allDayTimeOff = false,
  thisMonth = true,
  bookingsData = [],
  journalNoteDates = [],
  onJournalClick
}) => {
  const {
    content,
    isJournalModalOpen,
    isBookingModalOpen,
    selectedDate,
    selectedBookingId,
    handleCancel,
    handleBookingCancel,
    isPastDay,
    setJournalOpen,
    useExternalJournalHandler
  } = useDayCell({ day, timeOffRanges, allDayTimeOff, bookingsData, journalNoteDates, onJournalClick })

  const classes = ["d-flex flex-column"]

  return (
    <>
      <div
        className={
          `${classes.join(" ")} ${styles.showOnHover} ${styles.dayCellContainer} ` +
          (thisMonth ? "" : styles.notCurrentMonthDay + " ")
        }
        aria-disabled={isPastDay}
      >
        {content}
      </div>
      {!useExternalJournalHandler && isJournalModalOpen && (
        <Journal
          open={isJournalModalOpen}
          setOpen={setJournalOpen}
          onCancel={handleCancel}
          selectedDate={selectedDate}
          startDate={monthStartDate}
          endDate={monthEndDate}
        />
      )}
      {isBookingModalOpen && (
        <BookingDetailsModal open={isBookingModalOpen} handleOnCancel={handleBookingCancel} bookingUuid={selectedBookingId} />
      )}
    </>
  )
}


DayCell.propTypes = {
  day: PropTypes.instanceOf(moment).isRequired,
  monthStartDate: PropTypes.string,
  monthEndDate: PropTypes.string,
  timeOffRanges: PropTypes.arrayOf(PropTypes.string),
  allDayTimeOff: PropTypes.bool,
  thisMonth: PropTypes.bool,
  bookingsData: PropTypes.array,
  journalNoteDates: PropTypes.array,
  onJournalClick: PropTypes.func
}

DayCell.defaultProps = {
  monthStartDate: moment(),
  monthEndDate: moment(),
  timeOffRanges: [],
  allDayTimeOff: false,
  thisMonth: true,
  bookingsData: [],
  journalNoteDates: []
}

export default memo(DayCell)
